<template>
	<div class="main-contents">
		<!-- 로그인 폼 -->
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>403 Forbidden!!</span><br/>
					권한이 없습니다.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
		};
	},
	methods: {
	},
	computed: {
	}
};
</script>